export default class Modulo {
    public CODICE: string;
    public DESCRIZIONE: string;

    public constructor(codice: string, descrizione: string) {
        this.CODICE = codice;
        this.DESCRIZIONE = descrizione;
    }

}